import React from 'react'

const JobListingHeaderInternal = ({ html }) => {
  return (
    <>
      <span dangerouslySetInnerHTML={{ __html: html }}></span>
    </>
  )
}

export default JobListingHeaderInternal
